import { ApiService } from './api.service';
import type { Relation } from '@risk-management/shared';

export interface CreateRelationDto {
  fromEntityId: string;
  toEntityId: string;
  type: string;
  description?: string;
  criticality?: 'critical' | 'high' | 'medium' | 'low';
  protocol?: string;
  port?: number;
  isEncrypted?: boolean;
}

export interface UpdateRelationDto {
  fromEntityId?: string;
  toEntityId?: string;
  type?: string;
  description?: string;
  criticality?: 'critical' | 'high' | 'medium' | 'low';
  protocol?: string;
  port?: number;
  isEncrypted?: boolean;
}

class RelationsService extends ApiService {
  constructor() {
    super();
  }

  /**
   * Get all relations for a specific entity (component)
   */
  async getByEntityId(entityId: string): Promise<Relation[]> {
    return this.get(`/relations/entity/${entityId}`);
  }

  /**
   * Get a specific relation by ID
   */
  async getById(id: string): Promise<Relation> {
    return this.get(`/relations/${id}`);
  }

  /**
   * Create a new relation
   */
  async create(data: CreateRelationDto): Promise<Relation> {
    return this.post('/relations', data);
  }

  /**
   * Update an existing relation
   */
  async update(id: string, data: UpdateRelationDto): Promise<Relation> {
    return this.patch(`/relations/${id}`, data);
  }

  /**
   * Delete a relation
   */
  async deleteRelation(id: string): Promise<void> {
    await super.delete(`/relations/${id}`);
  }

  /**
   * Get all relations (optionally filtered by team)
   */
  async getAll(teamId?: string): Promise<Relation[]> {
    const params = teamId ? `?teamId=${teamId}` : '';
    return this.get(`/relations${params}`);
  }
}

export const relationsService = new RelationsService();
